module.exports = __webpack_public_path__ + "static/media/our-tests-thc-image.c957fea1.jpg";